import { render, staticRenderFns } from "./MachineTranslations.vue?vue&type=template&id=7131d6ff&"
import script from "./MachineTranslations.vue?vue&type=script&lang=js&"
export * from "./MachineTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7131d6ff')) {
      api.createRecord('7131d6ff', component.options)
    } else {
      api.reload('7131d6ff', component.options)
    }
    module.hot.accept("./MachineTranslations.vue?vue&type=template&id=7131d6ff&", function () {
      api.rerender('7131d6ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MachineTranslations.vue"
export default component.exports